export enum SectorType {
    Billing = 3,
    Reception = 2
}
